import React, { useEffect, useState } from "react";
import { Box, Typography, Grid, Paper, CircularProgress } from "@mui/material";
import { useNavigate } from "react-router-dom";
import to from "await-to-js";
import { axiosWithAuth } from "../plugins/axios";
import { getAPIUrlByRole } from "../lib/utils/config";
import { useRole } from "../lib/contexts/RoleContext";

// const apiUrl = process.env.REACT_APP_PIPELINE_API;

const Dashboard = () => {
  const navigate = useNavigate();
  // const [loading, setLoading] = useState(true);
  const [dashboardData, setDashboardData] = useState<any>(null);
  const [error, setError] = useState<string | null>(null);
  const [autoGraderVsManual, setAutoGraderVsManual] = useState<string>("N/A");
  const [dashboardLoading, setDashboardLoading] = useState(true);
  const [metricsLoading, setMetricsLoading] = useState(true);;
  const role = useRole();
  const apiUrl = getAPIUrlByRole(role);

  // const fetchDashboardData = async () => {
  //   setLoading(true);
  //   const [err, response] = (await to(
  //     axiosWithAuth(`${apiUrl}autoGrade/dashboard`, {}, "get")
  //   )) as any;

  //   if (err) {
  //     setError("Failed to load dashboard data");
  //     setLoading(false);
  //     return;
  //   }

  //   setDashboardData(response.data);

  //   const [metricErr, metricResponse] = (await to(
  //     axiosWithAuth(`${apiUrl}autoGrade/dashboard/overallMetrics`, {}, "get")
  //   )) as any;

  //   if (metricErr) {
  //     setError("Failed to load overallMetrics data");
  //     setLoading(false);
  //     return;
  //   }
  //   setAutoGraderVsManual(metricResponse.data?.overallMetrics?.overallAccuracy);

  //   setLoading(false);
  // };

  // useEffect(() => {
  //   fetchDashboardData();
  // }, []);

  useEffect(() => {

    const fetchDashboard = async () => {
      setDashboardLoading(true);
      try {
        const response = await axiosWithAuth(`${apiUrl}autoGrade/dashboard`, {}, "get");
        setDashboardData(response.data);
      } catch (err) {
        setError("Failed to load dashboard data");
      } finally {
        setDashboardLoading(false);
      }
    };
  

    const fetchMetrics = async () => {
      setMetricsLoading(true);
      try {
        const metricResponse = await axiosWithAuth(
          `${apiUrl}autoGrade/dashboard/overallAccuracyOnly`,
          {},
          "get"
        );
        setAutoGraderVsManual(metricResponse?.data?.autoGraderVsManual);
      } catch (err) {
        setError("Failed to load overall metrics");
      } finally {
        setMetricsLoading(false);
      }
    };
  
    fetchDashboard();
    fetchMetrics();
  }, [apiUrl]);

  if (dashboardLoading) {
    return (
      <Box mt={4} display="flex" justifyContent="center">
        <CircularProgress />
      </Box>
    );
  }

  if (metricsLoading) {
    return (
      <Box mt={4} display="flex" justifyContent="center">
        <CircularProgress />
      </Box>
    );
  }

  if (error) {
    return (
      <Box mt={4}>
        <Typography color="error">{error}</Typography>
      </Box>
    );
  }
  const formatTime = (seconds: number | null) => {
    if (!seconds || isNaN(seconds)) return "N/A";
    const minutes = Math.floor(seconds / 60);
    const secs = Math.floor(seconds % 60);
    return `${minutes}m ${secs}s`;
  };

  const navigateTo = `${
    role === "learn"
      ? "/performanceDashboard/listOfQuizzes"
      : "/performanceDashboard/listOfQuizzes"
  }`;

  const navigateToReportFailed = `${
    role === "learn"
      ? "/performanceDashboard/evaluationsFailedReport"
      : "/performanceDashboard/evaluationsFailedReport"
  }`;

  const navigateToReportQueue= `${
    role === "learn"
      ? "/performanceDashboard/evaluationsQueueReport"
      : "/performanceDashboard/evaluationsQueueReport"
  }`;


  const navigateToNotStarted = "/performanceDashboard/evaluationsNotStartedReport";

  const stats = dashboardData
    ? [
        {
          value: autoGraderVsManual || "N/A",
          label: "AutoGrader vs Manual",
          showIcon: true,
          navigateTo: navigateTo,
        },
        {
          value: dashboardData.submissionEvaluated || "N/A",
          label: "Submissions Evaluated",
        },
        {
          value: dashboardData.evaluationFailed || "N/A",
          label: "Evaluations Failed",
          showIcon: true,
          navigateTo: navigateToReportFailed,
        },
        {
          value: dashboardData.evaluationsInQueue || "0",
          label: "Evaluations-In-Queue",
          showIcon: true,
          navigateTo: navigateToReportQueue,
        },
        ...(role === "prism"
          ? [
              {
                // value: "N/A",
                label: "Not-Started Cases",
                showIcon: true,
                navigateTo: navigateToNotStarted,
              },
            ]
          : []),
        // { value:formatTime(dashboardData.avgTimePerEvaluation), label: "Avg. Time/Evaluation" },
        // { value: formatTime(dashboardData.fastestEvaluation), label: "Fastest Evaluation" },
      ]
    : [];

  const handleNavigation = (path: string) => {
    navigate(path);
  };

  //   return (
  //     <Box display="flex">
  //       {/* Main Content */}
  //       <Box flexGrow={1} p={4}>
  //         {loading ? (
  //           <Box display="flex" justifyContent="center" alignItems="center" height="100vh">
  //             <CircularProgress />
  //           </Box>
  //         ) : (
  //           <Grid container spacing={3}>
  //             {stats.map((stat, index) => (
  //               <Grid item xs={12} sm={6} md={4} key={index}>
  //                 <Paper
  //                   elevation={2}
  //                   sx={{ p: 4, textAlign: "center", height: "150px", display: "flex", flexDirection: "column", justifyContent: "center" }}
  //                 >
  //                   <Typography variant="h4" fontWeight={600}>
  //                     {stat.value}
  //                   </Typography>
  //                   <Typography variant="body1" mt={1}>
  //                     {stat.label}
  //                   </Typography>
  //                   {stat.showIcon && (
  //                     <Box display="flex" justifyContent="center" mt={1}>
  //                       <svg
  //                         xmlns="http://www.w3.org/2000/svg"
  //                         viewBox="0 0 24 24"
  //                         width="24"
  //                         height="24"
  //                         color="#000000"
  //                         fill="none"
  //                         style={{ cursor: "pointer", transition: "transform 0.2s" }}
  //                         onMouseEnter={(e) => e.currentTarget.style.transform = "scale(1.2)"}
  //                         onMouseLeave={(e) => e.currentTarget.style.transform = "scale(1)"}
  //                         onClick={() => handleNavigation(stat.navigateTo)}
  //                       >
  //                         <path d="M10 8L13.3322 11.0203C14.2226 11.8273 14.2226 12.1727 13.3322 12.9797L10 16" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  //                         <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="1.5" />
  //                       </svg>
  //                     </Box>
  //                   )}
  //                 </Paper>
  //               </Grid>
  //             ))}
  //           </Grid>
  //         )}
  //       </Box>
  //     </Box>
  //   );
  // };

  const formatLastRefreshedTime = (utcTimestamp: string) => {
    if (!utcTimestamp) return "N/A";
    try {
      const date = new Date(utcTimestamp);
      const day = date.getDate();
      const month = date.toLocaleString("en-IN", { month: "long" });
      const year = date.getFullYear();
      const time = date.toLocaleString("en-IN", {
        timeZone: "Asia/Kolkata",
        hour: "2-digit",
        minute: "2-digit",
        hour12: true,
      });

      // Add ordinal suffix (st, nd, rd, th) to the day
      const getOrdinalSuffix = (day: number) => {
        if (day > 3 && day < 21) return "th"; // 4th to 20th
        switch (day % 10) {
          case 1:
            return "st";
          case 2:
            return "nd";
          case 3:
            return "rd";
          default:
            return "th";
        }
      };

      return `${day}${getOrdinalSuffix(day)} ${month} ${year}, ${time}`;
    } catch (error) {
      console.error("Error parsing date:", error);
      return utcTimestamp || "N/A";
    }
  };
  return (
    <Box display="flex" flexDirection="column">
      <Box
        position="absolute"
        right="200px"
        top="95px"
        display="flex"
        alignItems="center"
        gap={1}
      >
        <Typography fontSize={16} fontWeight={600}>
          Last refreshed at :
        </Typography>
        <span>
          {dashboardData?.lastRefreshedAt
            ? formatLastRefreshedTime(dashboardData.lastRefreshedAt)
            : "N/A"}
        </span>
      </Box>
      <Box flexGrow={1} p={4}>
        <Grid container spacing={3}>
          {stats.map((stat, index) => (
            <Grid item xs={18} sm={9} md={6} key={index}>
              <Paper
                elevation={2}
                sx={{
                  p: 4,
                  textAlign: "center",
                  height: "150px",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                }}
              >
                <Typography variant="h4" fontWeight={600}>
                  {stat.value}
                </Typography>
                <Typography variant="body1" mt={1}>
                  {stat.label}
                </Typography>
                {stat.showIcon && (
                  <Box display="flex" justifyContent="center" mt={1}>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 24 24"
                      width="24"
                      height="24"
                      color="#000000"
                      fill="none"
                      style={{
                        cursor: "pointer",
                        transition: "transform 0.2s",
                      }}
                      onMouseEnter={(e) =>
                        (e.currentTarget.style.transform = "scale(1.2)")
                      }
                      onMouseLeave={(e) =>
                        (e.currentTarget.style.transform = "scale(1)")
                      }
                      onClick={() => handleNavigation(stat.navigateTo)}
                    >
                      <path
                        d="M10 8L13.3322 11.0203C14.2226 11.8273 14.2226 12.1727 13.3322 12.9797L10 16"
                        stroke="currentColor"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <circle
                        cx="12"
                        cy="12"
                        r="10"
                        stroke="currentColor"
                        strokeWidth="1.5"
                      />
                    </svg>
                  </Box>
                )}
              </Paper>
            </Grid>
          ))}
        </Grid>
      </Box>
    </Box>
  );
};

export default Dashboard;
